/* The Pending Approvals queue (piece 8; piece 22): three sections of rows on the To-Do page's shape, each row its facts on the left and its two decisions on the right. */
.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.sections {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.heading {
  margin: 0;
  font-size: var(--section-label-size);
  font-weight: var(--section-label-weight);
  letter-spacing: var(--section-label-tracking);
  color: var(--section-label-color);
  text-transform: uppercase;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3);
  border: 1px solid var(--tile-border);
  border-radius: var(--radius-medium);
  background: var(--surface);
  box-shadow: var(--tile-shadow);
}

.main {
  display: flex;
  flex: 1 1 60%;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  font-weight: var(--font-weight-bold);
}

/* The row's document-type chip, which leads the row so the kinds read down the list. */
.typePill {
  display: inline-flex;
  font-weight: var(--font-weight-regular);
}

.meta {
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

/* T973: a row's number links to the document's own page, in the link color the rest of the page uses. */
.numberLink {
  color: var(--navy-primary);
}

/* Decision 8960: a File Release's Open the record, the To-Do page's link. */
.link {
  align-self: flex-start;
  color: var(--navy-primary);
  font-size: var(--font-size-small);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.inline {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}
